import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import routing from "routing";
import { DeckCard } from "src/components/NewComponents/Search/DecksViews/DeckCard";
import { useDeckActions } from "src/hooks/useDeckActions";
import type { SearchDeck } from "src/hooks/useFlashcards";

interface UserDeckCardProps {
	deck: SearchDeck;
	className?: string;
}

export function UserDeckCard({ deck, className }: UserDeckCardProps) {
	const { t } = useTranslation();
	const menuItems = useDeckActions(deck);

	const primaryAction = {
		label: t("menuActions.flashcards.resolve", "Rozwiąż zestaw"),
		to: generatePath(routing.paths.flashcardsApp, { deckId: deck.code }),
		testId: `user-deck-open-${deck.code}`,
	};

	return (
		<DeckCard
			deck={deck}
			menuItems={menuItems}
			className={className}
			primaryAction={primaryAction}
		/>
	);
}
